import { push } from "connected-react-router";
import React, {useState} from "react";
import { useDispatch } from "react-redux";
import { ROUTE_PATH, APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE, APPLICATION_MODE_NEW, APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION } from "../../../app/constants";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import { replaceUrlParams } from '../../../app/utils'
import {
  Header,
  Paragraph,
  NavigationLinkButton,
  Button,
} from "../../../components/RegularComponents";
import { ERROR_STRING } from "../../../app/errors";
import { setCurrentAgentLicenceSubType } from "../../../redux/slice/additionalApplicationsSlice";
// import { setMortgageProperty } from "../../redux/slice/primaryAgencyApplicationSlice";

const applicationType = APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE;
const applicationMode = APPLICATION_MODE_NEW;

export const AssociateBrokerContinueApplication = (props) => {
  const dispatch = useDispatch();
  const [applicationSaveError, setApplicationSaveError] = useState(false);

  return (
    <div className="container">
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-10">
          <Header
            style={{ paddingBottom: "30px" }}
            id="associate-broker-continue-application-header"
            header="Continue to apply for an associate broker licence"
          />
        </div>
      </div>

      <div className="row">
        <div style={{paddingBottom:"20px"}} className="col-xs-12 col-lg-9">
          Based on the information provided, the applicant is elibile to apply for an Associate Mortgage Broker Licence.
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12">
          <Paragraph
            style={{ paddingBottom: "20px" }}
            id="associate-broker-continue-application-text"
            text={[
              "Continue to apply for an Associate Mortgage Broker licence for the applicant",
            ]}
          />
        </div>
      </div>

      <div className="row">
      <div className="col-lg-2 ">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={()=>{
              // set the application's licence subtype to ASSOCIATE_BROKER
              dispatch(setCurrentAgentLicenceSubType(
                LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION))

                dispatch(
                    saveBusinessLicenceApplicationData(
                      applicationType,
                      applicationMode
                    )
                  )
                .then((data) => {
                    dispatch(
                        push({
                            pathname: `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_ASSOCIATE_HAS_EDUCATION}`,
                        })
                    );
                })
                .catch((err) => {
                    setApplicationSaveError(true);
                });
            }}
            text={"Continue"}
          />
        </div>
        <div style={{marginLeft: "25px", marginTop: "45px"}} className="col-xs-12 col-lg-8">
          <NavigationLinkButton
            id={"cancel-quick-link"}
            text={"Save application and return home"}
            onClick={() => {

                let nextUrl = replaceUrlParams(ROUTE_PATH.WELCOME, 
                  APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, applicationMode)

                // On to the next item
                dispatch(
                    saveBusinessLicenceApplicationData(
                      applicationType,
                      applicationMode
                    )
                  )
                .then((data) => {
                    dispatch(
                        push(nextUrl)
                    );
                })
                .catch((err) => {
                    setApplicationSaveError(true);
                });
            
            }}
          />
            {applicationSaveError && (
              <div className="ns-error-message help-block topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};
